// extracted by mini-css-extract-plugin
export default {"ModalBody":"_ModalBody--cxh1f","Description":"_Description--US7Fa","Button":"_Button--YDjxI","OpenModalButton":"_OpenModalButton--xHWb7"};